import { ReactNode } from "react";

export type Props = {
  /** Render function for login link */
  renderLoginLink?: () => ReactNode;
  /** Render function for terms and privacy links */
  renderTermsAndPrivacy?: () => ReactNode;
  /** Container className */
  className?: string;
};

/**
 * Base signup additional content component - unstyled, uses render props for flexibility.
 * Wrap with styled version in shared/features/auth.
 */
export function SignupAdditionalContentBase({
  renderLoginLink,
  renderTermsAndPrivacy,
  className,
}: Props) {
  return (
    <div className={className} data-testid="signup-additional-content">
      {renderLoginLink?.()}
      {renderTermsAndPrivacy?.()}
    </div>
  );
}

export default SignupAdditionalContentBase;

